export default class BookingSearch extends HTMLElement {
    readonly #resetSearchButtons: HTMLButtonElement[] = [];

    protected connectedCallback(): void {
        this.#resolveElements();

        this.#resetSearchButtons.forEach((button) => {
            button.addEventListener('click', this.#clickListener.bind(this));
        });
    }

    protected disconnectedCallback(): void {
        this.#resetSearchButtons.forEach((button) => {
            button.removeEventListener('click', this.#clickListener.bind(this));
        });
    }

    #resolveElements(): void {
        const resetButton = this.querySelector('[data-role="clear"]');

        if (!resetButton) {
            return;
        }

        this.#resetSearchButtons.push(resetButton as HTMLButtonElement);

        const statusPanel = this.querySelector('[data-role="no-search-results"]');

        if (!statusPanel) {
            return;
        }

        const infoPanelResetButton = statusPanel.querySelector('[data-role="cta"]');

        if (!infoPanelResetButton) {
            return;
        }

        this.#resetSearchButtons.push(infoPanelResetButton as HTMLButtonElement);
    }

    #clickListener(): void {
        const url = new URL(window.location.href);
        if (url.searchParams.has('bookingId')) {
            window.location.href = window.location.pathname;
        }
    }
}

if (!customElements.get('booking-search')) {
    customElements.define('booking-search', BookingSearch);
}
